var _defs, _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconPrinter(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#003d5b;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M22.4,18.5H19.271a.521.521,0,0,1,0-1.042H22.4A1.564,1.564,0,0,0,23.958,15.9V8.6A1.564,1.564,0,0,0,22.4,7.042H2.6A1.564,1.564,0,0,0,1.042,8.6V15.9A1.564,1.564,0,0,0,2.6,17.458H5.729a.521.521,0,0,1,0,1.042H2.6A2.607,2.607,0,0,1,0,15.9V8.6A2.607,2.607,0,0,1,2.6,6H22.4A2.607,2.607,0,0,1,25,8.6V15.9A2.607,2.607,0,0,1,22.4,18.5Z",
    transform: "translate(0 0.25)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M14.771,21.042H8.521a.521.521,0,0,1,0-1.042h6.25a.521.521,0,0,1,0,1.042Z",
    transform: "translate(0.333 0.833)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M14.771,19.042H8.521a.521.521,0,1,1,0-1.042h6.25a.521.521,0,1,1,0,1.042Z",
    transform: "translate(0.333 0.75)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M10.6,17.042H8.521a.521.521,0,1,1,0-1.042H10.6a.521.521,0,1,1,0,1.042Z",
    transform: "translate(0.333 0.667)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M19.062,7.292a.521.521,0,0,1-.521-.521V2.6a1.564,1.564,0,0,0-1.562-1.562H7.6A1.564,1.564,0,0,0,6.042,2.6V6.771A.521.521,0,0,1,5,6.771V2.6A2.607,2.607,0,0,1,7.6,0h9.375a2.607,2.607,0,0,1,2.6,2.6V6.771A.521.521,0,0,1,19.062,7.292Z",
    transform: "translate(0.208)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M16.979,24.458H7.6a2.607,2.607,0,0,1-2.6-2.6V13.521A.521.521,0,0,1,5.521,13H19.062a.521.521,0,0,1,.521.521v8.333A2.607,2.607,0,0,1,16.979,24.458ZM6.042,14.042v7.812A1.564,1.564,0,0,0,7.6,23.417h9.375a1.564,1.564,0,0,0,1.563-1.562V14.042Z",
    transform: "translate(0.208 0.542)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPrinter);
export default __webpack_public_path__ + "static/media/iconPrinter.01945ad3a61eb7933dc307cec4b9eb7d.svg";
export { ForwardRef as ReactComponent };